import $ from 'jquery';

const mobileMenuBreakpoint = 1200;
const $win = $(window);
const $body = $('body');

const $header = $('.site-header-wrap');
const $headerMenu = $('.site-header .site-header__menu');
const $headerNav = $('.site-header .site-header__nav');

function NavigateMobileSubMenu(level, $subMenu) {
    $subMenu = $subMenu || null;
    if($subMenu) {
        $headerMenu.find('.sub-menu[data-depth=' + level + ']').removeClass('active');
        $subMenu.addClass('active');
    }
    $headerMenu.css('transform', 'translate(' + (-100 * level) + '%)');
    $headerNav.attr('data-currentlevel', level);
}

$('.site-header .sub-menu-back').click(function () {
    const level = $(this).attr('data-backlevel');
    NavigateMobileSubMenu(level);
});

$('.site-header .menu-item-has-children').each(function (){
    const $self = $(this);
    const $link = $self.find('> a');
    const $subMenu = $self.find('> .sub-menu');
    const $subMenuBack = $subMenu.find('> .sub-menu__back');

    const linkHref = $link.attr('href');

    if(linkHref !== '#' && linkHref !== '' && linkHref !== undefined) {
        const $menuItemDuplicate = $('<li class="menu-item menu-item--duplicate"></li>');
        $link.clone().appendTo($menuItemDuplicate);
        $subMenuBack.after($menuItemDuplicate);
    }

    $link.click(function (event) {
        console.log('CLICKED');
        if($win.width() <= mobileMenuBreakpoint) {
            console.log('HEY Prevent');
            event.preventDefault();
            NavigateMobileSubMenu($subMenu.attr('data-depth'), $subMenu);
        }
    });
});

$('.mobile-close, .mobile-menu-toggle').click(function () {
    $headerNav.toggleClass('open');
    $(this).toggleClass('is-active');
});

// Add header height as css var.
function setMenuHeightVar() {
    $body.css('--header-height', $header.height() + 'px');
}

// Do this on page load
setMenuHeightVar();

// Do this on resize
window.addEventListener('resize', event => {
    setMenuHeightVar();
});

//ADA Compliance fixes
$(document).ready(function(){
    $('#cook-an-boardman-pre-install-video video').attr('aria-describedby', 'cook-and-boardman-pre-install-video')
    $('.icon--arrow-icon').attr('aria-hidden', 'true');
    $('.icon--arrow-icon').attr('role', 'none');
    $('.icon--access-control-permissions-services').attr('aria-hidden', 'true');
    $('.icon--access-control-permissions-services').attr('role', 'none');
    $('.icon--aftermarket-replacement-and-repair-services').attr('aria-hidden', 'true');
    $('.icon--aftermarket-replacement-and-repair-services').attr('role', 'none');
    $('.icon--alarm-monitoring-services').attr('aria-hidden', 'true');
    $('.icon--alarm-monitoring-services').attr('role', 'none');
    $('.icon--budgeting-and-estimation-services').attr('aria-hidden', 'true');
    $('.icon--budgeting-and-estimation-services').attr('role', 'none');
    $('.icon--burglar-and-fire-alarms-services').attr('aria-hidden', 'true');
    $('.icon--burglar-and-fire-alarms-services').attr('role', 'none');
    $('.icon--cctv-integrator-services').attr('aria-hidden', 'true');
    $('.icon--cctv-integrator-services').attr('role', 'none');
    $('.icon--checkmark-icon').attr('aria-hidden', 'true');
    $('.icon--checkmark-icon').attr('role', 'none');
    $('.icon--chevron-icon').attr('aria-hidden', 'true');
    $('.icon--chevron-icon').attr('role', 'none');
    $('.icon--commercial-industry').attr('aria-hidden', 'true');
    $('.icon--commercial-industry').attr('role', 'none');
    $('.icon--education-industries').attr('aria-hidden', 'true');
    $('.icon--education-industries').attr('role', 'none');
    $('.icon--data-centers-industry-icon').attr('aria-hidden', 'true');
    $('.icon--data-centers-industry-icon').attr('role', 'none');
    $('.icon--emergency-repairs-services').attr('aria-hidden', 'true');
    $('.icon--emergency-repairs-services').attr('role', 'none');
    $('.icon--entertainment-industries').attr('aria-hidden', 'true');
    $('.icon--entertainment-industries').attr('role', 'none');
    $('.icon--fire-door-inspection-services').attr('aria-hidden', 'true');
    $('.icon--fire-door-inspection-services').attr('role', 'none');
    $('.icon--hardware-maintenance-and-service-services').attr('aria-hidden', 'true');
    $('.icon--hardware-maintenance-and-service-services').attr('role', 'none');
    $('.icon--headset-icon').attr('aria-hidden', 'true');
    $('.icon--headset-icon').attr('role', 'none');
    $('.icon--healthcare-industry').attr('aria-hidden', 'true');
    $('.icon--healthcare-industry').attr('role', 'none');
    $('.icon--hospitality-services').attr('aria-hidden', 'true');
    $('.icon--hospitality-services').attr('role', 'none');
    $('.icon--industrial-industries').attr('aria-hidden', 'true');
    $('.icon--industrial-industries').attr('role', 'none');
    $('.icon--installation-services').attr('aria-hidden', 'true');
    $('.icon--installation-services').attr('role', 'none');
    $('.icon--location-pin').attr('aria-hidden', 'true');
    $('.icon--location-pin').attr('role', 'none');
    $('.icon--location-pin-filled').attr('aria-hidden', 'true');
    $('.icon--location-pin-filled').attr('role', 'none');
    $('.icon--locksmithing-services').attr('aria-hidden', 'true');
    $('.icon--locksmithing-services').attr('role', 'none');
    $('.icon--page-icon').attr('aria-hidden', 'true');
    $('.icon--page-icon').attr('role', 'none');
    $('.icon--person-icon').attr('aria-hidden', 'true');
    $('.icon--person-icon').attr('role', 'none');
    $('.icon--person-icon-filled').attr('aria-hidden', 'true');
    $('.icon--person-icon-filled').attr('role', 'none');
    $('.icon--project-management-services').attr('aria-hidden', 'true');
    $('.icon--project-management-services').attr('role', 'none');
    $('.icon--quick-service-convience-stores-industries').attr('aria-hidden', 'true');
    $('.icon--quick-service-convience-stores-industries').attr('role', 'none');
    $('.icon--retail-industries').attr('aria-hidden', 'true');
    $('.icon--retail-industries').attr('role', 'none');
    $('.icon--search-magnifying-glass-icon').attr('aria-hidden', 'true');
    $('.icon--search-magnifying-glass-icon').attr('role', 'none');
    $('.icon--select-arrow-icon').attr('aria-hidden', 'true');
    $('.icon--select-arrow-icon').attr('role', 'none');
    $('.icon--shopping-cart-icon').attr('aria-hidden', 'true');
    $('.icon--shopping-cart-icon').attr('role', 'none');
    $('.icon--specification-and-design-services-icon').attr('aria-hidden', 'true');
    $('.icon--specification-and-design-services-icon').attr('role', 'none');
    $('.menu-item').attr('role','menuitem');
    $('.menu-item a').attr('role', 'menuitem');
    $('img').attr('role','img');
    $('input[type=submit]').attr('role','button');
    $('input[type=reset]').attr('role','button');
    $('input[type=checkbox]').attr('role','checkbox');
    $('input[type=button]').attr('role','button');
    $('input[type=email]').attr('role','textbox');
    $('input[type=search]').attr('role','searchbox');
    $('input[type=text]').attr('role','textbox');
    $('input[type=tel]').attr('role','textbox');
});
